const colors = require('tailwindcss/colors');

module.exports = {
  transparent: 'transparent',
  current: 'currentColor',
  inherit: 'inherit',
  white: colors.white,
  gray: {
    ...colors.neutral,
    200: '#f0eeeb',
    400: '#A8A8A8',
    600: '#5B645B',
    800: '#474545',
  },
  green: {
    ...colors.emerald,
    50: '#D7F8E9',
    100: '#e1faee',
    200: '#cae3da',
    600: '#239C65',
    DEFAULT: '#36DC90',
  },
  lilac: {
    ...colors.violet,
    50: '#f5f1fd',
    100: '#e7def9',
    300: '#CEB9F3',
    400: '#AC91DE',
    500: '#8268B0',
    600: '#7C5BB6',
  },
  yellow: {
    ...colors.amber,
    100: '#F8E9D7',
    500: '#DC9238',
    DEFAULT: '#F59E0B',
  },
  red: {
    ...colors.red,
    300: '#f3b8a8',
    900: '#61210D',
    DEFAULT: '#E34E20',
  },
  indigo: {
    ...colors.indigo,
    200: '#b2c0e1',
    500: '#611DDA',
  },
  zinc: {
    ...colors.zinc,
    400: '#eeefee'
  },
  black: '#000F00',
};
